<template>
  <div class="is-lowercase is-pulled-right is-size-7 has-text-weight-light">
    v{{ version }}
  </div>
</template>

<script setup lang="ts">
  const version = __APP_VERSION__;
</script>
